/**
 * Метод сдвига элемента массива на определенную позицию
 * @param arr
 * @param initialPosition
 * @param finalPosition
 */
export const arrayShiftElementImmutable = <T = string>(
  arr: T[],
  initialPosition: number,
  finalPosition: number
): T[] => {
  if (
    initialPosition === finalPosition ||
    arr[initialPosition] === undefined ||
    arr[finalPosition] === undefined
  ) {
    return arr;
  }

  const copy = arr.slice();

  const [element] = copy.splice(initialPosition, 1);

  return [
    ...copy.slice(0, finalPosition),
    element,
    ...copy.slice(finalPosition),
  ];
};
